import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import { toast } from 'react-toastify';

import LoadingIndicator from '../../components/loading-indicator/loading';

import ProjectsService from '../../api/services/ProjectsService';
import ItemsService from '../../api/services/ItemsService';
import { loadProjects } from '../../redux/actions/projectActions';
import { loadFacilities } from '../../redux/actions/facilityActions';
import Dropdown from '../../components/data-dropdown/dropdown';

function ImageDownload({
    facilities,
    projects,
    loadFacilities,
    loadProjects
}) {
    const [facilityId, setFacilityId] = useState(1);
    const [sourceProjectId, setSourceProjectId] = useState('');
    const [destinationProjectId, setDestinationProjectId] = useState('');
    const [destinationProjectHasItems, setDestinationProjectHasItems] = useState(false)
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => { 
        loadFacilities(sourceProjectId).catch(error => {
            alert('Loading facilities failed: ' + error)
        });
    }, [sourceProjectId]);

    useEffect(() => {
        loadProjects(facilityId).catch(error => {
            alert('Loading projects failed: ' + error)
        });
    }, [facilityId]);

    useEffect(() => {
        setDestinationProjectHasItems(false);

        if (destinationProjectId) {
            getDestinationProjectItemCount();
        }
    }, [facilityId, sourceProjectId, destinationProjectId])

    const getDestinationProjectItemCount = () => {
        if (destinationProjectId !== '') {
            ProjectsService.getItemCountForProject(destinationProjectId).then(result => {
                setDestinationProjectHasItems(result.count > 0);
            })
        }
    };

    const facilityHandleChange = (event) => {
        setFacilityId(event.target.value);
    };

    const sourceProjectHandleChange = (event) => {
        setSourceProjectId(event.target.value);
    };


    const validate = () => {
        const errors = [];
        if (sourceProjectId === '') {
            errors.push('A source and destination project are required.');
        }

        if (!facilityId || facilityId.length === 0) {
            errors.push('A warehouse selection is required.');
        }

        // NOTE: We were checking for existing items in the destination customer
        // But as of W3PL-29, we are "merging" items

        return errors;
    }

    const reset = () => {
        setSourceProjectId('');
        setDestinationProjectId('');
        setDestinationProjectHasItems(false);
    }

    function onSubmitDownload(event) {
        event.preventDefault();

        const validationErrors = validate();
        if (validationErrors.length > 0) {
            toast.error(validationErrors.join(' \n'))
            return;
        }

        setIsProcessing(true);
        ItemsService.downloadItemImages(sourceProjectId, facilityId)
            .then(response => {
                setIsProcessing(false);
                toast.success(`${response.itemsTransferred} items have been downloaded.`);
                reset();
            })
            .catch(error => {
                setIsProcessing(false);
                toast.error('There was an error downloading the items: ' + error);
            })
    }
    return (
        <div>
            <section className="dashboard card">                
                <article>
                    <h1>Download Images</h1>

                    <form>
                        <Dropdown 
                            name="Warehouse"
                            currentValue={facilityId}
                            handleChange={facilityHandleChange}
                            data={facilities}
                        ></Dropdown>
                        
                        <Dropdown 
                            name="Source Project"
                            currentValue={sourceProjectId}
                            handleChange={sourceProjectHandleChange}
                            data={projects}
                        ></Dropdown>
                    </form>

                    <br /><br />

                    <Button type="submit" variant="contained" color="primary" onClick={onSubmitDownload} disabled={isProcessing}>
                        Start Download
                    </Button>
                    
                    <LoadingIndicator visible={isProcessing} />
                </article>
            </section>
        </div>
    )
}

ImageDownload.propTypes = {
    facilities: PropTypes.array.isRequired,
    projects: PropTypes.array.isRequired,
    loadFacilities: PropTypes.func.isRequired,
    loadProjects: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        facilities: state.facilities,
        projects: state.projects
    }
}

const mapDispatchToProps = {
    loadFacilities,
    loadProjects
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageDownload);